import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'COMPONENTS/BILL_PAYER_FORM';

export const {
    action: search,
    success: searchSuccess,
    failed: searchFailed,
} = createAction(`${domain}/SEARCH`, (institutionId, childId, term, billPayerType) => ({
    institutionId,
    childId,
    term,
    billPayerType,
}));

export const {action: reset} = createAction(`${domain}/reset`, () => ({}));
